// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__20upH","resendInfoText":"OnGoingPaymentBox_resendInfoText__Fm19V"};